<template>
    <div class="transformer">
        <div class="title">逆变器监测</div>
        <div class="content">
            <div class="transformerList">
                <div class="search">
                    <el-input
                        placeholder="输入设备名称以搜索"
                        suffix-icon="el-icon-search"
                        @change="search"
                        v-model="keyword">
                    </el-input>
                </div>
                <div class="list">
                    逆变器列表
                </div>
                <el-menu
                    default-active="1-1"
                    background-color="#fff"
                    text-color="#333"
                    :default-openeds="openeds"
                    active-text-color="#0D94FF" v-if="currentInverterList.length >0">
                    <el-submenu :index="index + 1 + ''" v-for="(item, index) in currentInverterList" :key="item.areaId">
                        <template slot="title">
                            <span>{{item.areaName}}</span>
                        </template>
                        <el-menu-item :index="(index + 1) + '-' + (idx + 1)" v-for="(inverter, idx) in item.InverterList" :key="inverter.device_id"
                        @click="selectInverter(inverter)"
                        >{{inverter.loop_name}}</el-menu-item>
                        
                    </el-submenu>
                </el-menu>
                <div class="nothing" v-else>暂无数据</div>
            </div>
            <div class="transformerDetails">
                <Inverter :inverter="inverter" v-if="Object.keys(inverter).length > 0"/>
                <RunAnalysis :inverter="inverter" v-if="Object.keys(inverter).length > 0"/>
                <div class="nothing" v-if="Object.keys(inverter).length == 0">
                    <img src="../../assets/img/not_found_data.png" alt="">
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
const RunAnalysis = () => import('./components/RunAnalysis.vue')
const Inverter = () => import('./components/Inverter.vue')

import { getInverters } from '../../api/power'
import { subscribe,subscribeByNodes } from '../../mqtt/index'

export default {
    data(){
        return {
            keyword:'',
            InverterList:[],
            inverter:{},
            currentInverterList:[],
            openeds:['1', '2']
        }
    },
    components:{
        RunAnalysis, Inverter
    },
    mounted(){
        this.getInverter()
    },
    methods:{
        selectInverter(inverter){
            // console.log(inverter);
            this.inverter = inverter
        },
        async getInverter(){
            let res = await getInverters({
                projectId:this.$store.getters.projectId
            })
            if(res.data.code == 200){
                let list = []
                res.data.data.devices.forEach((item ,index)=>{
                    if(list.length == 0){
                        let site = {
                            areaName:item.area_name,
                            areaId:item.area_id,
                            InverterList:[item]
                        }
                        list.push(site)
                        if(item.loop_url){
                            subscribe([item.loop_url.split('/').splice(1).join('/')])
                        }
                    }else{
                        let site = list.find(item2 =>item2.areaId == item.area_id)
                        if(site){
                            site.InverterList.push(item)
                            if(item.loop_url){
                                subscribe([item.loop_url.split('/').splice(1).join('/')])
                            }
                        }else{
                            let site = {
                                areaName:item.area_name,
                                areaId:item.area_id,
                                InverterList:[item]
                            }
                            list.push(site)
                            if(item.loop_url){
                                subscribe([item.loop_url.split('/').splice(1).join('/')])
                            }
                        }
                    }
                })

                this.InverterList = list
                this.currentInverterList = list
                if(list.length >0){
                    this.selectInverter(list[0].InverterList[0])
                }
                
            }else{
                // console.log(res.data.errMsg);
            }
        },
        search(e){
            // console.log(e);
            let current = []
            this.InverterList.forEach(item =>{
                let searchT = item.InverterList.filter(item2 =>{
                    return item2.loop_name.indexOf(e) != -1
                })
                // console.log(searchT);
                // console.log(item);
                if(searchT.length >0){
                    let area = {
                        areaId:item.areaId,
                        areaName:item.areaName,
                        InverterList:searchT
                    }
                    current.push(area)
                }
            })
            // console.log(current);
            this.currentInverterList = current
            if(current.length > 0){
                this.selectInverter(current[0].InverterList[0])
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
.transformer{
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(17,35,59,0.16);

    .title{
        height: 5vh;
        line-height: 5vh;
        padding: 0 24px;
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }

    .content{
        height: calc(100% - 5vh);
        display: flex;
        padding:16px 0;
        box-sizing: border-box;

        .transformerList{
            width: 24.5%;
            height: 100%;
            border-right: 1px solid rgba(0, 0, 0, 0.15);
            padding: 0 24px;

            .search{
                /deep/ .el-input__inner{
                    height: 4vh;
                    line-height: 4vh;
                    font-size: 14rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                }
                /deep/ .el-input__suffix{
                    cursor: pointer;
                }
            }
            .list{
                height: 5vh;
                line-height: 6vh;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
            }
            /deep/ .el-menu{
                border-right: none;
                .el-submenu {
                    margin-bottom: 1.2vh;

                    .el-menu{
                        border: 1px solid #F2F2F2;
                        border-radius: 0px 0px 4px 4px;
                    }

                    .el-icon-arrow-down:before {
                        font-size: 18rem;
                        font-weight: bold;
                        color: #333;
                    }

                    .el-menu-item{
                        height: 4vh;
                        line-height: 4vh;
                        margin: 0.6vh 0;
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #666666 !important;
                        position: relative;
                        &:hover{
                            background-color: rgba(13,148,255, 0.07) !important;
                            color: #0D94FF !important;
                            border-radius: 4px;

                            &::before{
                                content:'';
                                background: url('../../assets/img/line-a.png') no-repeat;
                            }
                        }
                        &::before{
                            content:'';
                            width:7px ;
                            height: 14px;
                            background: url('../../assets/img/line.png') no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            left: 20px;
                            top: 50%;
                            transform: translate(0, -50%);
                        }
                    }
                    .el-menu-item.is-active {
                        background-color: rgba(13,148,255, 0.07) !important;
                        color: #0D94FF !important;
                        border-radius: 4px;

                        &::before{
                            content:'';
                            background: url('../../assets/img/line-a.png') no-repeat;
                        }
                    }
                }
            }
            /deep/.el-submenu__title{
                background-color: #F2F2F2 !important;
                border-radius: 4px;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                height: 4vh;
                line-height: 4vh;
            }

            /deep/.el-submenu__title i {
                rotate: -90deg !important;
            }
            /deep/.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
                transform: rotateZ(90deg)!important;
            }
        }
        .transformerDetails{
            width: 75.5%;
            height: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
            padding: 0 1vw;
            .nothing{
                width: 100%;
                height: 100%;
                position: relative;
                &>img{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
}
</style>